import React, { Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { unauthenticatedRoutes } from "../../configs/routes/unauthenticatedRoutes";
import Loading from "../shared/Loading";
import RedirectHome from "./RedirectHome";
const routes = unauthenticatedRoutes.map(({ component: Component, ...route }) => (<Route key={route.path} component={() => (<Suspense fallback={<Loading />}>
        <Component />
      </Suspense>)} {...route} exact/>));
const UnauthenticatedApp = () => (<Switch>
    {routes}
    <RedirectHome />
  </Switch>);
export default UnauthenticatedApp;
